import { BookOpen } from "lucide-react";
import { useGuidesStore } from "@/stores/useGuidesStore";

/**
 * Dedicated TopNav launcher for the Guides catalog (walkthroughs, replay tour,
 * suggestion prefs). The JourneyBar retirement (PR #6) repurposed the "?"
 * HelpCircle to open the "Where am I?" overlay, leaving the catalog with no
 * direct entry point — this restores it as a separate icon.
 */
export function GuidesCatalogTrigger() {
  const setCatalogOpen = useGuidesStore((s) => s.setCatalogOpen);

  return (
    <button
      type="button"
      onClick={() => setCatalogOpen(true)}
      aria-label="Open guides"
      data-tour-target="guides-catalog-button"
      className="flex size-8 items-center justify-center rounded-md border border-border text-muted-foreground hover:border-primary hover:text-primary"
      title="Guides & walkthroughs"
    >
      <BookOpen className="size-4" />
    </button>
  );
}
